import { SubmissionDraftClient } from 'clients';
import { QueryKeys } from 'enums';
import { SubmissionDraft, SubmissionDraftCreate, SubmissionDraftSearch } from 'types';
import { MutateProps, UseQueryBaseSearchOptions } from './query/types';
import { useMutate } from './query/useMutate';
import { useQuerySearch } from './query/useQuery';

export function useSearchSubmissionDrafts(props: UseQueryBaseSearchOptions<SubmissionDraft, SubmissionDraftSearch>) {
  const { filter, queryOptions, enabled } = props;

  return useQuerySearch({
    queryKey: QueryKeys.SubmissionDrafts,
    clientClass: SubmissionDraftClient,
    filter,
    enabled,
    queryOptions: {
      ...queryOptions,
    },
  });
}

export function useMutateSubmissionDraft(options?: MutateProps) {
  const { create, update } = useMutate<SubmissionDraft, SubmissionDraft, SubmissionDraftCreate, SubmissionDraftClient>({
    queryKey: QueryKeys.SubmissionDrafts,
    clientClass: SubmissionDraftClient,
    cancelInvalidation: options?.cancelInvalidation,
    createOptions: { throwOnError: true },
    updateOptions: { throwOnError: true },
  });

  return { createSubmissionDraft: create.mutateAsync, updateSubmissionDraft: update.mutateAsync };
}
